import { api } from "@/api";

// Read-only Scoremer catalogue search behind sinek-api. Shapes mirror
// sinek-api/src/services/internalApi/searchScoremer.ts; the panel never
// talks to Scoremer itself.

export type ScoremerRaceStatus = "scheduled" | "live" | "finished" | "other";

// Which Scoremer catalogue to search. Race and team ids repeat across sports,
// so the sport is part of every call; football is the server default.
export type ScoremerSearchSport = "football" | "basketball";

export interface ScoremerTeamCandidate {
  id: number;
  name: string;
  country: string;
  countryCode: string | null;
  lastActivityAt: string | null;
}

export interface ScoremerRaceCandidate {
  raceId: number;
  url: string;
  kickoffAt: string | null;
  home: string;
  away: string;
  homeBetradarId: string | null;
  awayBetradarId: string | null;
  league: string;
  countryName: string | null;
  status: ScoremerRaceStatus;
  statusCode: string;
  homeScore: number | null;
  awayScore: number | null;
}

export type ScoremerTeamSearchOutcome =
  | { kind: "candidates"; teams: ScoremerTeamCandidate[] }
  | { kind: "empty"; reason: "no-team-matched" };

export type ScoremerRaceListOutcome =
  | { kind: "candidates"; races: ScoremerRaceCandidate[] }
  | { kind: "empty"; reason: "no-race-for-team" };

export const searchScoremerTeams = async (
  name: string,
  sportType: ScoremerSearchSport,
  signal?: AbortSignal
): Promise<ScoremerTeamSearchOutcome> => {
  const res = await api.client.get("/matches/scoremer/teams", {
    params: { name, sportType },
    signal,
  });
  return res.data;
};

export const getScoremerTeamRaces = async (
  teamId: number,
  sportType: ScoremerSearchSport,
  signal?: AbortSignal
): Promise<ScoremerRaceListOutcome> => {
  const res = await api.client.get(
    `/matches/scoremer/teams/${teamId}/races`,
    { params: { sportType }, signal }
  );
  return res.data;
};

// Every ranked team of one search, merged and newest first — the "Tümü"
// view. Served from the pages the search already fetched, so it is not a
// second round trip to the catalogue.
export const getScoremerSearchRaces = async (
  name: string,
  sportType: ScoremerSearchSport,
  signal?: AbortSignal
): Promise<ScoremerRaceListOutcome> => {
  const res = await api.client.get("/matches/scoremer/races", {
    params: { name, sportType },
    signal,
  });
  return res.data;
};
